import { IComponentController } from "angular";
import { IEcranDetailsResourcesEntite } from '../../../../../core/resources/ecran-details.resource';
import { IFormulaireItemSautDeLigneClass } from '../../../../../core/services/formulaire/formulaire-item-saut-de-ligne.service';
import { IFormulaireItemClass } from '../../../../../core/services/formulaire/formulaire-item.service';
import { IFormulaireClass } from '../../../../../core/services/formulaire/formulaire.service';
import { IMonoOccurrenceOptions } from "../../../../../core/services/mono-occurrence.service";
import { IStateParamsService } from "angular-ui-router";

interface IPagePb0011 extends IComponentController {
    monoOccurrenceOptions: IMonoOccurrenceOptions;
}

/* @ngInject */
export default function Pb0011Controller(Formulaire: IFormulaireClass,
    FormulaireItem: IFormulaireItemClass,
    ecranDetails: IEcranDetailsResourcesEntite,
    $stateParams: IStateParamsService,
    FormulaireItemSautDeLigne: IFormulaireItemSautDeLigneClass) {
    const vm: IPagePb0011 = this;

    vm.monoOccurrenceOptions = {
        noId: true,
        formulaire: new Formulaire([
            new FormulaireItem('pveann', {
                default: $stateParams.pveann,
                largeur: 25
            }),
            new FormulaireItem('pvedatdeb', {
                default: ecranDetails.valeurs.pvedatdeb,
                largeur: 25
            }),
            new FormulaireItem('pvedatfin', {
                default: ecranDetails.valeurs.pvedatfin,
                largeur: 25
            }),
            new FormulaireItem('pcstyp', {
                default: ecranDetails.valeurs.pcstyp,
                largeur: 25
            }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('intcod', {
                default: ecranDetails.valeurs.intcod,
                largeur: 25
            }),
            new FormulaireItem('intnom', {
                default: ecranDetails.valeurs.intnom,
                largeur: 25
            }),
            new FormulaireItem('prucod', {
                default: ecranDetails.valeurs.prucod,
                largeur: 25
            }),
            new FormulaireItem('prudscl01', {
                default: ecranDetails.valeurs.prudscl01,
                largeur: 25
            }),
            new FormulaireItemSautDeLigne(),
            new FormulaireItem('posnumdoc', {
                default: ecranDetails.valeurs.posnumdoc,
                largeur: 25
            }),
            new FormulaireItem('postit', {
                default: ecranDetails.valeurs.postit,
                largeur: 25
            }),
            new FormulaireItem('eplnummat', {
                default: ecranDetails.valeurs.eplnummat,
                largeur: 25
            }),
            new FormulaireItem('eplnomprn', {
                default: ecranDetails.valeurs.eplnomprn,
                largeur: 25
            })
        ])
    };

    vm.pcsMultiOccurrenceOptions = {
        fonctions: {
            rechercheCollapsable: false,
            exportation: false
        },
        colonnesFixesGauche: [
            { nom: 'pcsdatdeb', largeur: 120 },
            { nom: 'pcsdatfin', largeur: 120 },
            { nom: 'pcssalanc', largeur: 110 },
            { nom: 'unccod_anc', largeur: 110 },
            { nom: 'pcssalnou', largeur: 110 },
            { nom: 'unccod_nou', largeur: 110 },
            { nom: 'pcstauhoranc', largeur: 110 },
            { nom: 'pcstauhornou', largeur: 110 },
            { nom: 'couqtecal', largeur: 190 }
        ],
        colonnesVisibles: [
            { nom: 'cousyssal', largeur: 110, total: true },
            { nom: 'cousysavs', largeur: 110, total: true },
            { nom: 'prcavs', largeur: 110 },
            { nom: 'coucumtot', largeur: 110, total: true },
            { nom: 'pcsdsc', largeur: 110 }
        ]
    };
}
